export const SPOTIFY_CODE = 'SPOTIFY_CODE';
export const SPOTIFY_TOKEN = 'SPOTIFY_TOKEN';
export const SPOTIFY_REFRESH_TOKEN = 'SPOTIFY_REFRESH_TOKEN';
export const SPOTIFY_TOKEN_EXPIRES_AT = 'SPOTIFY_TOKEN_EXPIRES_AT';
export const SPOTIFY_USER_INFO = 'SPOTIFY_USER_INFO';
/** Active profile needs Spotify re-authorization (refresh invalid_grant) */
export const SPOTIFY_NEEDS_RECONNECT = 'SPOTIFY_NEEDS_RECONNECT';
/** Non-secret snapshot of profile that failed reauth (for CTA copy / OAuth intent) */
export const SPOTIFY_RECONNECT_PROFILE = 'SPOTIFY_RECONNECT_PROFILE';
/** OAuth intent: reconnect | add_profile | first_connect */
export const SPOTIFY_OAUTH_INTENT = 'SPOTIFY_OAUTH_INTENT';
/** Mongo UsersProfile _id for the active own profile */
export const SPOTIFY_ACTIVE_PROFILE_ID = 'SPOTIFY_ACTIVE_PROFILE_ID';
/** One-time reconnect feedback shown after returning from the OAuth callback */
export const SPOTIFY_RECONNECT_NOTICE = 'SPOTIFY_RECONNECT_NOTICE';
export const AUTH0_USER_INFO = 'AUTH0_USER_INFO';
export const REMEMBER_ME = 'REMEMBER_ME';
export const USER_PROFILE = 'USER_PROFILE';
